'use client'
import { AbsoluteCenter } from '@chakra-ui/react'
import { useComponentTranslation } from '@core/i18n'
import { Box, Divider, Flex, Tag, Text } from '@core/ui-elements'
import { ICheckingItem, IPickingProduct } from '@data/types'
import { getValidBarCodes, removeLastHyphen } from '@utils/formatters'
import { FC, useMemo } from 'react'

import { FallbackImageError } from '../fallback-image-error'
import { LastCharactersStrong } from '../last-characters-strong'
import { LoadingScreen } from '../loading-screen'

export interface IProductInformation {
  product: IPickingProduct | ICheckingItem
  hideLocation?: boolean
}

export const ProductInformation: FC<IProductInformation> = ({
  product,
  hideLocation,
}) => {
  const t = useComponentTranslation('ProductInformation')

  const location = useMemo(
    () =>
      removeLastHyphen(
        product.location?.includes('@')
          ? product.location?.split('@')[1]
          : (product.location as string)
      ),
    [product.location]
  )

  if (!product) return <LoadingScreen />

  return (
    <Flex flexDirection={'column'} gap={'0.25rem'} padding="0">
      <Flex justifyContent="center">
        <FallbackImageError
          alt={product.name}
          height="11rem"
          imageUrl={product.imageUrl}
        />
      </Flex>
      <Text as={'strong'} fontSize="large" textAlign={'center'}>
        {product.name}
      </Text>
      {!hideLocation && (
        <Box marginY={'1rem'} position={'relative'} width="100%">
          <Divider borderWidth={'0.0625rem'} color={'gray.100'} />
          <AbsoluteCenter
            backgroundColor={'white'}
            maxWidth="80%"
            padding={'0.5rem'}
            width="max-content"
          >
            <Tag
              bgColor="gray.100"
              fontWeight="600"
              letterSpacing="0.1rem"
              size="lg"
              width="100%"
            >
              {location}
            </Tag>
          </AbsoluteCenter>
        </Box>
      )}
      <Box>
        <Text color="gray.600" fontSize={'0.875rem'} textAlign={'center'}>
          {t('Code')}{' '}
          <LastCharactersStrong
            color="var(--chakra-colors-blue-500)"
            fontWeight="600"
            label={
              product?.barcodes && product?.barcodes.length > 0
                ? getValidBarCodes(product.barcodes)[0]
                : ''
            }
          />
        </Text>
      </Box>
    </Flex>
  )
}
